<template>
    <div>
        <form @submit.prevent="on_submit" id="submit_form">
            <div class="row">
                <div class="col-12 my-2">
                    <div class="h5" v-text="$t('wallets.label.settlement')"></div>
                </div>
                <div class="col-12 my-2">
                    <label for="withdraw_type" v-text="$t('wallets.label.withdraw_type')"></label>
                    <select class="form-control" id="withdraw_type" name="withdraw_type" v-model="form_data.withdraw_type">
                        <option v-for="(wt, index) in withdrawType"
                                :key="index"
                                :value="wt"
                                v-text="withdrawTypeStr.get(wt)"
                        >
                        </option>
                    </select>
                </div>

                <template v-if="form_data.withdraw_type === withdrawType.INTERNAL">
                    <div class="col-12 col-md-6 my-2">
                        <label for="internal_destination_deposit"
                               v-text="$t('wallets.label.destination_deposit')"
                        >
                        </label>
                        <input class="form-control"
                               id="internal_destination_deposit"
                               name="internal_destination_deposit"
                               dir="ltr"
                               v-model="form_data.internal_destination_deposit"
                        >
                    </div>
                    <div class="col-12 col-md-6 my-2">
                        <label for="internal_amount"
                               v-text="$t('label.amount_rial')"
                        >
                        </label>
                        <input class="form-control"
                               id="internal_amount"
                               name="internal_amount"
                               dir="ltr"
                               v-model="form_data.internal_amount"
                        >
                    </div>
                </template>

                <template v-else-if="form_data.withdraw_type === withdrawType.INTERNAL_GROUP">
                    <div v-for="(item, index) in form_data.internal_group_destination_batch_transfers"
                         :key="index"
                         class="row col-12"
                    >
                        <div class="col-6 my-2">
                            <label>
                                <span v-text="$t('wallets.label.destination_deposit')"></span>
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   :name="`internal_group_destination_batch_transfers_${index}_destination_deposit_number`"
                                   v-model="form_data.internal_group_destination_batch_transfers[index].destination_deposit_number"
                            >
                        </div>
                        <div class="col-6 my-2">
                            <label>
                                <span v-text="$t('label.amount_rial')"></span>
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   :name="`internal_group_destination_batch_transfers_${index}_amount`"
                                   v-model="form_data.internal_group_destination_batch_transfers[index].amount"
                            >
                        </div>
                    </div>

                    <div class="col-12 my-2">
                        <button class="btn btn-danger mr-2 px-2 text-center"
                                type="button"
                                @click="removeInternalGroupItem()"
                        >
                            <i class="text-center px-2 fas fa-minus"></i>
                        </button>
                        <button class="btn btn-primary mx-auto px-2 text-center"
                                type="button"
                                @click="addInternalGroupItem()"
                        >
                            <i class="text-center mx-auto px-2 fas fa-plus"></i>
                        </button>
                    </div>
                </template>

                <template v-else-if="form_data.withdraw_type === withdrawType.PAYA">
                    <div class="col-12 col-md-4 my-2">
                        <label for="paya_iban_number"
                               v-text="$t('wallets.label.destination_iban_number')"
                        >
                        </label>
                        <input class="form-control"
                               id="paya_iban_number"
                               name="paya_iban_number"
                               dir="ltr"
                               v-model="form_data.paya_iban_number"
                        >
                    </div>
                    <div class="col-12 col-md-4 my-2">
                        <label for="paya_owner_name"
                               v-text="$t('wallets.label.destination_owner_name')"
                        >
                        </label>
                        <input class="form-control"
                               id="paya_owner_name"
                               name="paya_owner_name"
                               v-model="form_data.paya_owner_name"
                        >
                    </div>
                    <div class="col-12 col-md-4 my-2">
                        <label for="paya_amount"
                               v-text="$t('label.amount_rial')"
                        >
                        </label>
                        <input class="form-control"
                               id="paya_amount"
                               name="paya_amount"
                               dir="ltr"
                               v-model="form_data.paya_amount"
                        >
                    </div>
                </template>

                <template v-else-if="form_data.withdraw_type === withdrawType.PAYA_GROUP">
                    <div v-for="(item, index) in form_data.paya_group_transactions"
                         :key="index"
                         class="row col-12"
                    >
                        <div class="col-4 my-2">
                            <label>
                                <span v-text="$t('wallets.label.destination_iban_number')"></span>
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   :name="`paya_group_transactions_${index}_iban_number`"
                                   v-model="form_data.paya_group_transactions[index].iban_number"
                            >
                        </div>
                        <div class="col-4 my-2">
                            <label>
                                <span v-text="$t('wallets.label.destination_owner_name')"></span>
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   :name="`paya_group_transactions_${index}_owner_name`"
                                   v-model="form_data.paya_group_transactions[index].owner_name"
                            >
                        </div>
                        <div class="col-4 my-2">
                            <label>
                                <span v-text="$t('label.amount_rial')"></span>
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   :name="`paya_group_transactions_${index}_amount`"
                                   v-model="form_data.paya_group_transactions[index].amount"
                            >
                        </div>
                    </div>

                    <div class="col-12 my-2">
                        <button class="btn btn-danger mr-2 px-2 text-center"
                                type="button"
                                @click="removePayaGroupItem()"
                        >
                            <i class="text-center px-2 fas fa-minus"></i>
                        </button>
                        <button class="btn btn-primary mx-auto px-2 text-center"
                                type="button"
                                @click="addPayaGroupItem()"
                        >
                            <i class="text-center mx-auto px-2 fas fa-plus"></i>
                        </button>
                    </div>
                </template>

                <template v-else-if="form_data.withdraw_type === withdrawType.SATNA">
                    <div class="col-12 col-md-3 my-2">
                        <label for="satna_destination_iban_number"
                               v-text="$t('wallets.label.destination_iban_number')"
                        >
                        </label>
                        <input class="form-control"
                               id="satna_destination_iban_number"
                               name="satna_destination_iban_number"
                               dir="ltr"
                               v-model="form_data.satna_destination_iban_number"
                        >
                    </div>
                    <div class="col-12 col-md-3 my-2">
                        <label for="satna_receiver_name"
                               v-text="$t('wallets.label.destination_receiver_name')"
                        >
                        </label>
                        <input class="form-control"
                               id="satna_receiver_name"
                               name="satna_receiver_name"
                               v-model="form_data.satna_receiver_name"
                        >
                    </div>
                    <div class="col-12 col-md-3 my-2">
                        <label for="satna_receiver_family"
                               v-text="$t('wallets.label.destination_receiver_family')"
                        >
                        </label>
                        <input class="form-control"
                               id="satna_receiver_family"
                               name="satna_receiver_family"
                               v-model="form_data.satna_receiver_family"
                        >
                    </div>
                    <div class="col-12 col-md-3 my-2">
                        <label for="satna_amount"
                               v-text="$t('wallets.label.amount_rial_satna_limit')"
                        >
                        </label>
                        <input class="form-control"
                               id="satna_amount"
                               name="satna_amount"
                               dir="ltr"
                               v-model="form_data.satna_amount"
                        >
                    </div>
                </template>

                <template v-else-if="form_data.withdraw_type === withdrawType.SATNA_GROUP">
                    <div v-for="(item, index) in form_data.satna_group_transactions"
                         :key="index"
                         class="row col-12"
                    >
                        <div class="col-3 my-2">
                            <label>
                                <span v-text="$t('wallets.label.destination_iban_number')"></span>
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   :name="`satna_group_transactions_${index}_iban`"
                                   v-model="form_data.satna_group_transactions[index].iban"
                            >
                        </div>
                        <div class="col-3 my-2">
                            <label>
                                <span v-text="$t('wallets.label.destination_receiver_name')"></span>
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   :name="`satna_group_transactions_${index}_receiver_name`"
                                   v-model="form_data.satna_group_transactions[index].receiver_name"
                            >
                        </div>
                        <div class="col-3 my-2">
                            <label>
                                <span v-text="$t('wallets.label.destination_receiver_family')"></span>
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   :name="`satna_group_transactions_${index}_receiver_family`"
                                   v-model="form_data.satna_group_transactions[index].receiver_family"
                            >
                        </div>
                        <div class="col-3 my-2">
                            <label>
                                <span v-text="$t('wallets.label.amount_rial_satna_limit')"></span>
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   :name="`satna_group_transactions_${index}_amount`"
                                   v-model="form_data.satna_group_transactions[index].amount"
                            >
                        </div>
                    </div>

                    <div class="col-12 my-2">
                        <button class="btn btn-danger mr-2 px-2 text-center"
                                type="button"
                                @click="removeSatnaGroupItem()"
                        >
                            <i class="text-center px-2 fas fa-minus"></i>
                        </button>
                        <button class="btn btn-primary mx-auto px-2 text-center"
                                type="button"
                                @click="addSatnaGroupItem()"
                        >
                            <i class="text-center mx-auto px-2 fas fa-plus"></i>
                        </button>
                    </div>
                </template>

                <div class="col-12 mt-5 pt-5">
                    <button class="btn btn-success" type="submit" v-text="form_meta_data.submit_btn_text"></button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {i18n} from "@/plugins/i18n";
    import {withdrawType, withdrawTypeStr} from "@/constants/withdrawType";

    export default {
        data() {
            return {
                withdrawType,
                withdrawTypeStr,
            };
        },
        methods: {
            addInternalGroupItem() {
                if (this.form_data.internal_group_destination_batch_transfers.length > 100) {
                    return;
                }

                this.form_data.internal_group_destination_batch_transfers.push({
                    destination_deposit_number: '',
                    amount: '',
                });
            },
            removeInternalGroupItem() {
                if (this.form_data.internal_group_destination_batch_transfers.length < 3) {
                    return;
                }

                this.form_data.internal_group_destination_batch_transfers.pop();
            },

            addPayaGroupItem() {
                if (this.form_data.paya_group_transactions.length > 100) {
                    return;
                }

                this.form_data.paya_group_transactions.push({
                    iban_number: '',
                    owner_name: '',
                    amount: '',
                });
            },
            removePayaGroupItem() {
                if (this.form_data.paya_group_transactions.length < 3) {
                    return;
                }

                this.form_data.paya_group_transactions.pop();
            },

            addSatnaGroupItem() {
                if (this.form_data.satna_group_transactions.length > 100) {
                    return;
                }

                this.form_data.satna_group_transactions.push({
                    iban: '',
                    receiver_name: '',
                    receiver_family: '',
                    amount: '',
                });
            },
            removeSatnaGroupItem() {
                if (this.form_data.satna_group_transactions.length < 3) {
                    return;
                }

                this.form_data.satna_group_transactions.pop();
            },
        },
        props: {
            form_meta_data: {
                type: Object,
                default: () => {
                    return {
                        submit_btn_progress: false,
                        submit_btn_text: i18n.t('btn.submit'),
                    };
                },
            },
            on_submit: {
                type: Function,
                default: () => {
                },
            },
            form_data: {
                type: Object,
                default: () => {
                    return {};
                },
            },
        },
    }
</script>

<style scoped>
    .btn-danger {
        margin: 0 1rem;
    }
</style>
